import { Button, Grid, InputBase as MuiInputBase, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  // marginBottom:"20px",
  // gap:"56px",
  justifyContent: "space-between",
});

// export const Topbar = styled(Grid)({
//   width: "100%",
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",

//   "& svg": {
//     fontSize: "2em",
//   },
// });

export const QuickFilters = styled(Grid)({
  display: "flex",
});

export const SearchContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
}));

export const Search = styled("div")(({ theme }) => ({
  position: "relative",
  width: "100%",
  marginLeft: 0,
  [theme.breakpoints.up("md")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

export const InputBase = styled(MuiInputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

export const Icon = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "30px",
}));

export const DeleteButton = styled(Button)({
  fontSize: "1rem",
  padding: 0,
  cursor: "pointer",

  "&:hover": {
    backgroundColor: "transparent",
  },
});

export const Title = styled(Typography)({
  fontWeight: 500,
  paddingInlineEnd: "25px",
});

export const TitleContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "sticky",
})<{ sticky?: boolean }>(
  ({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    zIndex: 10,
  }),
  ({ sticky }) => ({
    ...(sticky && {
      // position: "sticky",
      top: 0,
    }),
  })
);

export const Toolbar = styled(Grid)({
  width: "100%",
  display: "flex",
  flexWrap: "nowrap",
  gap: "5px",
  alignItems: "flex-start",
  justifyContent: "space-between",
  // marginTop:"20px"
});

export const ToolbarInnerContainer = styled(Grid)({
  display: "flex",
  gap: "5px",
  alignItems: "flex-start",

  "& > .MuiDivider-root": {
    height: "40px",
    marginTop: "0px",
  },
});
